var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useState } from 'react';
import { styled } from '@web/theme';
import chroma from 'chroma-js';
export var AuthWrapper = function (_a) {
    var children = _a.children;
    var _b = useState(false), shown = _b[0], setShownState = _b[1];
    useEffect(function () { return setShownState(true); }, [shown]);
    return (React.createElement(Wrapper, null,
        React.createElement(Modal, null, children)));
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 900;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: auto;\n  height: auto;\n  font-family: ", ";\n  background: ", ";\n  pointer-events: auto;\n"], ["\n  z-index: 900;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: auto;\n  height: auto;\n  font-family: ", ";\n  background: ", ";\n  pointer-events: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.accent.bg).alpha(.8).hex();
});
var Modal = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 2;\n  display: flex;\n  border-radius: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  // min-width: 21rem;\n  // min-height: 27rem;\n  // max-height: 100%;\n  background: ", ";\n  padding: 4em 3em;\n  box-shadow: ", ";\n  \n  @media (max-width: 575.98px): {\n    width: 100%;\n    height: 100%;\n    padding: 2rem;\n  }\n"], ["\n  z-index: 2;\n  display: flex;\n  border-radius: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  // min-width: 21rem;\n  // min-height: 27rem;\n  // max-height: 100%;\n  background: ", ";\n  padding: 4em 3em;\n  box-shadow: ", ";\n  \n  @media (max-width: 575.98px): {\n    width: 100%;\n    height: 100%;\n    padding: 2rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.vars.baseBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.page.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.boxShadow.default;
});
var templateObject_1, templateObject_2;
